import { useEffect, useState } from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { HOME_LOGGED, MYCONTRACTS, SELECTDEPENDENTS } from "../../core/app-urls";
import PlansByClubModel from "../../data/models/PlansByClub";
import RelationshipModel from "../../data/models/relationship";
import { getRelationships } from "../../data/services/form_contract";
import {
  getPlansByClub,
  sendChangePlanNotification,
} from "../../data/services/person_service";
import { LeftContent, SelectionIndicator } from "../../styles/CancelPlan";
import {
  HeaderRow,
  Info,
  ListPlanCards,
  PlanCard,
  SelectPlanStyle,
  WrapContent,
} from "../../styles/SelectPlanModification";


export default function SelectPlanModification() {
  const navigate = useNavigate();
  const [categorias, setCategorias] = useState<PlansByClubModel[]>([]);
  const [planoSelecionado, setPlanoSelecionado] = useState<number | null>(null);
  const [nomePlano, setNomePlano] = useState<string | null>(null);
  const [planChange, setPlanChange] = useState<boolean | null>(null);
  const location = useLocation();
  const { idClube, idConvenio, idContrato, contractID } = location.state || {};
  //   const planoAtual = "Individual";

  const [relationships, setRelationships] = useState<RelationshipModel[]>([]);
  const [dependents, setDependents] = useState<
    { nome: string; telefone: string; cpf: string; email: string, relationship: string }[]
  >([]);


  useEffect(() => {
    async function fetchData() {
      const response = await getPlansByClub(idContrato);
      if (response.data) {
        setCategorias(response.data);
      }
    }

    const fetchRelationships = async () => {
      try {
        const { relationships } = await getRelationships();
        setRelationships(relationships);
      } catch (error) {
        console.error("Erro ao buscar parentescos:", error);
      }
    };

    fetchData();
    fetchRelationships();
  }, []);

  const handleSelecionarPlano = (idCategoria: number, nome: string) => {
    setPlanoSelecionado(idCategoria);
    setNomePlano(nome)
  };

  const handleChangePlan = async () => {
    if (planoSelecionado != null) {
      navigate(SELECTDEPENDENTS, {
        state: {
          idContrato,
          idConvenio,
          planoSelecionado,
          contractID,
          nomePlano
        },
      });
    } else {
      toast.error("É necessário selecionar um plano para prosseguir");
    }

  };

  const addDependent = () => {
    setDependents([
      ...dependents,
      { nome: "", telefone: "", cpf: "", email: "", relationship: "" },
    ]);
  };

  const removeDependent = (index: number) => {
    setDependents(dependents.filter((_, i) => i !== index));
  };

  const updateDependent = (index: number, field: string, value: string) => {
    setDependents((prev) =>
      prev.map((dependent, i) =>
        i === index ? { ...dependent, [field]: value } : dependent
      )
    );
  };

  return (
    <SelectPlanStyle>
      <ToastContainer />
      <WrapContent>
        <HeaderRow onClick={() => navigate(MYCONTRACTS)}>
          <IoArrowBackOutline size={24} />
          <h1>Solicitar alteração do Plano</h1>
        </HeaderRow>
          <Info>Um Email de confirmação será enviado assim que a empresa aprovar/desaprovar a solicitação</Info>
        {/* <SubTitle>Seu Plano Atual: {planoAtual}</SubTitle> */}
        <ListPlanCards>
          {categorias.map((cat) => (
            <PlanCard
              key={cat.idCategoria}
              onClick={() => handleSelecionarPlano(parseInt(cat.idCategoria), cat.categoria)}
              style={{ cursor: "pointer" }}
            >
              <div style={{ display: "flex", flexDirection: "row" }}>
                <SelectionIndicator
                  selected={parseInt(cat.idCategoria) === planoSelecionado}
                />
                <LeftContent>
                  <h2>Categoria: {cat.categoria}</h2>
                  <h2>Valor: {cat.valor}</h2>
                </LeftContent>
              </div>
            </PlanCard>
          ))}
        </ListPlanCards>

        {!planChange ? (
          <>
            <button onClick={() => handleChangePlan()}>
              Continuar com a solicitação
            </button>
          </>
        ) : (
          <>
            <button onClick={() => navigate(HOME_LOGGED)}>
              Retornar para a tela principal
            </button>
          </>
        )}
      </WrapContent>
    </SelectPlanStyle>
  );
}
